import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c65d7cf = () => interopDefault(import('../pages/shared/privacy-policy/index.vue' /* webpackChunkName: "" */))
const _b079c914 = () => interopDefault(import('../pages/shared/terms-conditions/index.vue' /* webpackChunkName: "" */))
const _59ca44e7 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "" */))
const _c9651724 = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/privacy-policy/",
    component: _1c65d7cf,
    name: "privacy-policy"
  }, {
    path: "/terms-conditions/",
    component: _b079c914,
    name: "terms-conditions"
  }, {
    path: "/",
    component: _59ca44e7,
    name: "home"
  }, {
    path: "/contact",
    component: _c9651724,
    name: "contact"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
